import React from "react";
import logoSrc from "assets/orangatamariki.png";
import { Typography } from "antd";

const Logo = () => (
	<div
		style={{
			display: "flex",
			padding: 5,
			justifyContent: "space-between",
		}}
	>
		<div className="qna-page-header-logo-only">
			<img src={logoSrc} alt="Company logo"></img>
			<br />
			<Typography.Text type="secondary" style={{ fontSize: "small" }}>
				v1.2.2
			</Typography.Text>
		</div>
		<div style={{ width: 400 }}>
			<Typography.Text type="secondary" style={{ fontSize: "smaller" }}>
				If you believe a child is in immediate danger or in a
				life-threatening situation contact Police immediately by dialing
				111.
			</Typography.Text>
		</div>
	</div>
);

const FormHeader = () => {
	return (
		<div
			className="qna-header-container"
			style={{
				position: "sticky",
				top: 0,
				zIndex: 1,
				width: "100%",
				backgroundColor: "white",
			}}
		>
			<Logo />
			<div className="site-page-header" style={{ padding: 5 }}>
				<Typography.Title
					level={4}
					style={{ display: "block", color: "white" }}
				>
					Report of Concern to Oranga Tamariki, Ministry for Children
				</Typography.Title>

				<div
					style={{ display: "flex", justifyContent: "space-between" }}
				>
					<Typography.Title
						level={5}
						style={{ display: "block", color: "white" }}
					>
						Call us on: 0508326459
					</Typography.Title>
				</div>
			</div>
		</div>
	);
};

export default FormHeader;
